var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgOpen = function SvgOpen(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Engagement-(Blast)-UI-Design-(D)",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10-D-SQ-Engagement_v2",
    transform: "translate(-1589.000000, -481.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "external-link-square-alt",
    transform: "translate(1589.000000, 481.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,1.39285714 L13,11.6071429 C13,12.3764063 12.3764063,13 11.6071429,13 L1.39285714,13 C0.62359375,13 0,12.3764063 0,11.6071429 L0,1.39285714 C0,0.62359375 0.62359375,0 1.39285714,0 L11.6071429,0 C12.3764063,0 13,0.62359375 13,1.39285714 Z M10.4464286,1.85714286 L7.19727009,1.85714286 C6.5788125,1.85714286 6.26637723,2.60757366 6.70480804,3.04603348 L7.63291518,3.97422768 L1.95914063,9.64800223 C1.82316295,9.78397991 1.82316295,10.0044576 1.95914063,10.1404643 L2.85953571,11.0408594 C2.99554241,11.1768371 3.21602009,11.1768371 3.35199777,11.0408594 L9.0257433,5.36711384 L9.95396652,6.29542411 C10.3900759,6.73147545 11.1428571,6.42527902 11.1428571,5.80296205 L11.1428571,2.55357143 C11.1428571,2.16893973 10.8310603,1.85714286 10.4464286,1.85714286 Z",
    id: "Shape"
  }))))));
};
export default SvgOpen;